import { useCallback } from 'react';
import store from '../components/authentication/store';
import { Provider } from 'react-redux';
import { AuthenticationFlowPageId } from 'src/components/authentication/AuthenticationFlow';
import { AuthenticationModal } from 'src/components/authentication/AuthenticationModal';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';
import { useAuth } from 'src/contexts/AuthContext';
import { useRedirectCallback } from './useRedirectCallback';

export const AUTH_MODAL_ID = 'AUTH_MODAL' as const;

export function useAuthModal() {
  const { union, remove } = useGlobalComponentsContext();
  const { isUnverified } = useAuth();

  const closeAuthModal = useCallback(() => {
    remove(AUTH_MODAL_ID);
  }, [remove]);

  useRedirectCallback(closeAuthModal);

  return {
    openAuthModal: (
      startPage?: AuthenticationFlowPageId,
      onClose?: () => void,
    ) => {
      if (isUnverified) {
        return;
      }
      union(
        AUTH_MODAL_ID,
        <Provider store={store}>
          <AuthenticationModal
            open={true}
            onClose={() => {
              if (!!onClose) {
                onClose();
              }
              remove(AUTH_MODAL_ID);
            }}
            body={<p>body</p>}
            startPage={startPage}
          />
        </Provider>,
      );
    },
    closeAuthModal,
  };
}
